import { render, staticRenderFns } from "./deleteProducts.vue?vue&type=template&id=34d797ea&scoped=true&"
import script from "./deleteProducts.vue?vue&type=script&lang=js&"
export * from "./deleteProducts.vue?vue&type=script&lang=js&"
import style0 from "./deleteProducts.vue?vue&type=style&index=0&id=34d797ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d797ea",
  null
  
)

export default component.exports